import type { IconProps } from '../types/IconProps.ts';
export const FileSymlink: IconProps = {
    name: 'FileSymlink',
    children: [
        `<path d="M4 11V4c0-1.1.9-2 2-2h7.17a2 2 0 0 1 1.42.59L19.4 7.4a2 2 0 0 1 .6 1.43V20a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-3c0-1.1.9-2 2-2h4" />`,
        `<path d="m8 12 2.96 2.96q.03.04 0 .08L8 18M14 3v5a1 1 0 0 0 1 1h5" />`,
    ]
};